<div>
  <div>
    <h4>Regional Managers</h4>
  </div>


  @if (rms?.length > 0) {
    <div class="p-grid">
      @for (rm of rms; track rm) {
        <div class="p-col-12">
          <hr/>
          <h5>{{rm.firstName}} {{rm.lastName}}</h5>
          <div>
            <p-button label="Go To Employee's RM Schedule" (click)="navigateToRMSchedulingPage(rm)" class="btn-margin" severity="info"></p-button>
            <p-button label="Go To Employee's Zip Code to Day Assignments" (click)="navigateToRMTimeSlotPage(rm)" severity="info"></p-button>
          </div>
        </div>
      }
    </div>
  }
  <hr>
    @if (!isLoading && rms.length <= 0) {
      <div class="fine-print">There aren't any Regional Managers in system.</div>
    }
    <div>
      @if (isLoading) {
        <span style="margin-left:8px">
          <i class="pi pi-spin pi-spinner" style="font-size: 3.5em"></i>
        </span>
      }
    </div>
  </div>